"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _styles = require("@material-ui/core/styles");

var _jssPluginRuleValueFunction = _interopRequireDefault(require("jss-plugin-rule-value-function"));

var jssPreset = function jssPreset() {
  var preset = (0, _styles.jssPreset)();
  preset.plugins = [].concat((0, _toConsumableArray2["default"])(preset.plugins), [(0, _jssPluginRuleValueFunction["default"])()]);
  return preset;
};

var _default = jssPreset;
exports["default"] = _default;